import isNaN from 'lodash/isNaN'
import isFinite from 'lodash/isFinite'

export const units = [
  '字节',
  'KB',
  'MB',
  'GB',
  'TB',
  'PB',
]

export default function (bytes, precision) {
  if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return
  let unit = 0
  while (bytes >= 1024 && units[unit + 1]) {
    bytes /= 1024
    unit++
  }
  return bytes.toFixed(+precision) + ' ' + units[unit]
}



// WEBPACK FOOTER //
// ./src/utils/filesize.js